import { assetRegisterNames } from "routes/asset-register/controller/asset-register-names"
import { emptyArray } from "lib/empty-array"

export function useAssetRegisterNameValidation(source) {
    const registerItems = assetRegisterNames.useResults() ?? emptyArray

    function validateRegisterName(value, yup) {
        return yup
            .string()
            .trim()
            .required()
            .test(
                "duplicate-register-name",
                `There is already an item named: '${getTrimmedName(value)}'. Please try again`,
                () => !isNameDuplicate(value)
            )
            .validateSync(value)
    }

    function isValid(value) {
        return isNameDuplicate(value?.name)
    }

    function isNameDuplicate(value) {
        const normalisedName = normaliseName(value)
        if (!normalisedName) return false

        return getComparableNames().some((name) => name === normalisedName)
    }

    function getComparableNames() {
        return registerItems
            .filter((item) => !isCurrentRegister(item))
            .map((item) => normaliseName(item?.name))
            .filter(Boolean)
    }

    function isCurrentRegister(item) {
        if (!source?.id) return false
        return item?.id === source.id
    }

    function normaliseName(value) {
        return getTrimmedName(value).toLowerCase()
    }

    function getTrimmedName(value) {
        if (value === null || value === undefined) return ""
        return String(value).trim()
    }

    function prepareOutput(value) {
        if (!value) return value

        return {
            ...value,
            name: value?.name?.trim(),
        }
    }

    return {
        validateRegisterName,
        isValid,
        prepareOutput,
    }
}
